import PageDataLoader from '../../../lib/page-data/loader';
import PageKey from '../../../lib/page-data/key';
import {
  TEAM_STATISTICS_PAGE_REQUEST,
  TEAM_STATISTICS_PAGE_RECEIVE,
  TEAM_STATISTICS_PAGE_FAILURE,
  PAGE_DATA_LOAD,
  SELECT_SEASON,
} from '../../action-types';

export const fetchStatisticsPageData = (clubId, teamId, seasonId, request) => async (dispatch) => {
  try {
    dispatch({ type: TEAM_STATISTICS_PAGE_REQUEST, payload: { clubId, teamId, seasonId } });
    dispatch({ type: SELECT_SEASON, payload: seasonId });
    const pageKey = new PageKey(clubId, 'statistics', { teamId, seasonId });
    const pageData = await PageDataLoader.getPageData(pageKey, request);
    const {
      seasons,
      fixtureStatistics,
      fixtureStatisticsBreakdown,
      keyPlayerStatistics,
      playerStatisticsTables,
    } = pageData.data;

    dispatch({
      type: TEAM_STATISTICS_PAGE_RECEIVE,
      payload: {
        clubId,
        teamId,
        seasonId,
        seasons,
        fixtureStatistics,
        fixtureStatisticsBreakdown,
        keyPlayerStatistics,
        playerStatisticsTables,
      },
    });
    dispatch({ type: PAGE_DATA_LOAD, payload: pageKey.toString() });

    return {};
  } catch (error) {
    let statusCode = 500;
    if (error) {
      statusCode = error.errorStatusCode || statusCode;
    }

    dispatch({
      type: TEAM_STATISTICS_PAGE_FAILURE,
      payload: { clubId, teamId, statusCode, error },
    });
    return { error };
  }
};
